import { getEditorPlugin,type SlateEditor } from '@udecode/plate';

import { type BaseCitationConfig,BaseCitationPlugin } from './BaseCitationPlugin';
import type { TCitationItemBase } from './types';

export type CitationOnSelectItem<
  TItem extends TCitationItemBase = TCitationItemBase,
> = (editor: SlateEditor, item: TItem, search?: string) => void;

export const getCitationOnSelectItem =
  <TItem extends TCitationItemBase = TCitationItemBase>({
        key = BaseCitationPlugin.key,
    }: { key?: string } = {}): CitationOnSelectItem<TItem> =>
        (editor, item, search = '') => {
            const { tf } = getEditorPlugin<BaseCitationConfig>(editor, {
                key: key as any,
            });

            tf.insert.citation({ key: item.key, search, value: item.text });

            // move the selection after the element
            editor.tf.move({ unit: 'offset' });
        };
